import securityRepository from "../repositories/SecurityRepository";

export class SecurityService {
  static GetUserPermissions(instance, activeUser) {
    const repo = new securityRepository;
    return repo.getUserPermissions(instance, activeUser).then();
  }

  static GetUserRoles(instance) {
    const repo = new securityRepository;
    return repo.getUserRoles(instance).then();
  }

  static GetUser(instance, userId) {
    const repo = new securityRepository;
    return repo.getUser(instance, userId).then();
  }

  static GetUsers(instance) {
    const repo = new securityRepository;
    return repo.getUsers(instance).then();
  }

  static UpdateUser(instance, payload) {
    const repo = new securityRepository;
    return repo.updateUser(instance, payload).then();
  }

  static GetAuditLogs(instance, userId) {
    const repo = new securityRepository;
    return repo.getAuditLogs(instance, userId).then();
  }

  static GetRegionUsers(instance, regionId) {
    const repo = new securityRepository;
    return repo.getRegionUsers(instance, regionId).then();
  }

  static UpdateRegionUser(instance, payloadActiveUser, payloadUser) {
    const repo = new securityRepository;
    return repo.updateRegionUser(instance, payloadActiveUser, payloadUser).then();
  }

  static GetUserByName(instance, name) {
    const repo = new securityRepository;
    return repo.getUserByName(instance, name).then();
  }

  static GetUserByNameOrRegion(instance, name) {
    const repo = new securityRepository;
    return repo.getUserByNameOrRegion(instance, name).then();
  }

  static GetDispatchers(instance) {
    const repo = new securityRepository;
    return repo.getDispatchers(instance).then();
  }

  static GetUserByIdMcLeod(instance, mcId) {
    const repo = new securityRepository;
    return repo.getUserByIdMcLeod(instance, mcId).then();
  }

  static GetUserByRoleId(instance, roleId) {
    const repo = new securityRepository;
    return repo.getUserByRoleId(instance, roleId).then();
  }
}